
import React from 'react';
import { SuccessHeader } from '@/components/interview/SuccessHeader';
import { SuccessFeedbackForm } from '@/components/interview/SuccessFeedbackForm';

const InterviewSuccess: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto py-12 px-4">
      <div className="bg-white rounded-lg shadow-sm p-8 text-center border-t-4 border-green-500">
        <SuccessHeader />
        <SuccessFeedbackForm />
      </div>
    </div>
  );
};

export default InterviewSuccess;
